<template>
  <SiteIndex v-if="isIndex" :model="model" :white-list="[]" />
  <site-shop-cart v-else-if="isShopCart" :model="model" />
</template>

<script>
import cloneDeep from "lodash.clonedeep";
import SiteCore, {
  postReady,
  getSiteBuilderDataByService,
  checkLogin,
  getIpInfo,
  checkVisitStatus,
  getSiteHead, checkDialogStatus
} from '~/site/core'
import SiteIndex from "~/site/components/siteIndex"
import SiteShopCart from "~/site/components/shopCartPage/index.vue"
import { useAssets } from "~/hooks/useAssets";
import langConfigMixins from "~/mixins/langConfigMixins";
import { PageNameEnum } from "~/enums/pageEnum";
import { removeDefaultManifest } from "~/utils/dom"
import tools from '~/utils'

export default {
  name: "SitePreview",
  components: {
    SiteIndex,
    SiteShopCart
  },
  mixins: [langConfigMixins],
  layout: 'defaultLayout',
  async asyncData({ redirect, app, params, route, store }) {
    return await getSiteBuilderDataByService({ redirect, app, route, params, store })
  },
  data() {
    return {
      deferredPrompt: null,
      native: null,
      model: null,
      lang: '',
      mid: '',
      pid: '',
      domain: '',
      pLang: '',
      langIdData: {},
      siteBuildId: '',
      siteInfo: {},
      baseInfo: {},
      pageList: [],
      web: {},
      languages: [],
      needParams: {}
    }
  },
  head() {
    return getSiteHead(this)
  },
  computed: {
    isIndex() {
      const { model } = this
      return !this.isShopCart && model
    },
    isShopCart() {
      const { pageId, model } = this
      return (pageId === PageNameEnum.SHOP_CART) && model
    }
  },
  mounted() {
    const { setSiteLangList } = useAssets(this)
    setSiteLangList(this.langList)
    this.setNewUrl()
    removeDefaultManifest()
  },
  methods: {
    // setConsole() {
    //   insertScript({
    //     src: 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js'
    //   }, () => {})
    // },
    // 设置语言
    async setNewUrl() {
      if (!this.pLang) {
        const { query, path } = this.$route
        const prefix = path.includes('/preview') ? `/preview/${this.siteBuildId}` : ''
        const sysLang = tools.getSysLanguage()
        const langArr = this.langList?.map(item => item.code) || []
        const curLang = langArr.includes(sysLang) ? sysLang : this.siteInfo.default_language
        this.pLang = curLang
        let queryParams = ''
        for (const key in query) {
          const value = query[key]
          if (value) {
            queryParams = `${queryParams}&${key}=${value}`
          }
        }
        const fullPath = `${prefix}${this.pageId ? `/${this.pageId}` : ''}/${curLang}${queryParams ? '?' + queryParams : ''}`
        await this.$router.push(fullPath)
      } else {
        await this.init()
      }
      this.$cookies.set('lang', this.pLang)
      tools.setFavicon(this?.siteInfo?.conf?.web.site?.seoSetting?.favicon)
    },
    async getCurrencies() {
      const res = await this.$api.common.getCurrencies()
      const map = {}
      res.data.forEach((c) => {
        map[c.id] = c
      })
      this.$store.commit('project/SET_CURRENCYINFO', {
        currency: res.data,
        currencieMap: map,
      })
    },
    async init() {
      try {
        await checkLogin(this)
        await getIpInfo(this)
        await checkVisitStatus(this)
        await this.getCurrencies()
        this.$store.commit('editor/SET_EDIT_MODE', false)
        const { baseInfo, siteInfo, languages, langList, pageList } = this
        const lang = this.pLang || this.siteInfo.default_language
        this.langIdData = await this.getLangConfig(lang, this.siteInfo.default_language, this.pid)
        const options = {
          editMode: false,
          baseInfo,
          siteInfo: siteInfo.conf,
          languages,
          langList,
          lang,
          langIdData: this.langIdData,
          pageList,
        }
        this.model = new SiteCore(options)
        this.$store.commit('locale/SET_LANG', lang)
        this.$store.commit('locale/SET_LANG_DATA', cloneDeep(this.langIdData))
        tools.setPageTitle(options.siteInfo?.web?.site?.seoSetting, this.langIdData)
        await checkDialogStatus(this)
        this.$nextTick(() => {
          postReady()
        })
      } catch (error) {
        return Promise.reject(error)
      }
    }
  }
}
</script>
